<template>
  <div
    :class="[`backdrop ${isOpenCreatePaymentBlock ? 'show-backdrop' : ''}`]"
    @click="setCloseCreatedWindow"
  >
    <div
      :class="[
        `payment-info-block ${
          isOpenCreatePaymentBlock ? 'open-payment-info-block' : ''
        }
    `,
      ]"
      @click.stop=""
    >
      <div class="create-payment-header-container">
        <div>
          <h2 class="create-payment-title">
            {{
              isEdit
                ? $t("homePage.editOperation")
                : $t("homePage.createOperation")
            }}
          </h2>
          <p v-if="isDrawEditMode" class="create-payment-under-title">
            {{ $t("homePage.notConfirmed") }}
          </p>
        </div>
        <button
          class="create-bayment-close-button"
          @click="setCloseCreatedWindow"
        >
          <x-icon class="create-payment-close-icon" />
        </button>
      </div>
      <vue-perfect-scrollbar class="create-block-scrollbar">
        <div class="change-status-payments-block">
          <button
            v-for="typeOperation of typeList"
            :key="typeOperation.id"
            :class="[
              `status-button 
            ${typeValue && typeValue.slug === typeOperation.slug && 'active'}`,
            ]"
            @click="checkListValueType(typeOperation)"
          >
            {{ typeOperation.title }}
          </button>
        </div>
        <p class="error-message" v-if="isShowError && !typeValue">
          {{ $t("category.requiredInput") }}
        </p>
        <tab-input
          :title="$t('homePage.summ')"
          :isPrice="true"
          :placeholder="'0'"
          :value="priceInputVal"
          :options="getCurrency"
          :listValue="usedCurrency"
          :inputId="'price-input'"
          @custom-input-val="saveCustomPriceValue"
          @check-list-value="checkListCurrency"
          @is-open-keyboard="isOpenKeyboard"
        />
        <p
          class="error-message"
          v-if="isShowError && (!priceInputVal || !usedCurrency)"
        >
          {{ $t("homePage.requiredPriceCurrency") }}
        </p>
        <date-input :title="$t('homePage.date')" />
        <tab-input
          :title="$t('homePage.title')"
          :placeholder="$t('homePage.typeName')"
          :value="titleInputVal"
          :inputId="'title-input'"
          @custom-input-val="saveCustomTitleValue"
          @is-open-keyboard="isOpenKeyboard"
        />
        <p class="error-message" v-if="isShowError && !titleInputVal">
          {{ $t("category.requiredInput") }}
        </p>
        <fixed-tab-list
          :title="$t('homePage.category')"
          :isLast="true"
          :options="operationsCategories"
          :value="categoryValue"
          @is-open-fixed-list="setIsOpenFixedList"
        />
        <p class="error-message" v-if="isShowError && !categoryValue">
          {{ $t("category.requiredInput") }}
        </p>
      </vue-perfect-scrollbar>
      <div v-if="isDrawEditMode" class="draw-buttons-main-container">
        <div class="change-operation-container">
          <button
            class="change-operation-button delete"
            @click="setDeleteOperation"
          >
            {{ $t("homePage.deleteOperation") }}
          </button>
          <button
            class="change-operation-button edit"
            @click="setConfirmOperation"
          >
            {{ $t("homePage.confirmOperation") }}
          </button>
        </div>
        <div class="edit-index-buttons-container">
          <button
            v-if="isShowDrawsIndex > 0"
            class="close-info-customer-modal next"
            @click="showPreviousDrawOperation"
          >
            {{ $t("homePage.previousOperation") }}
          </button>
          <button
            v-if="isShowDrawsIndex < drawOperations.length - 1"
            class="close-info-customer-modal previous"
            @click="showNextDrawOperation"
          >
            {{ $t("homePage.nextOperation") }}
          </button>
        </div>
      </div>
      <button
        v-else-if="!isHideMainButton"
        class="close-info-customer-modal"
        name="button"
        @click="createNewOperation"
      >
        {{ isEdit ? $t("category.edit") : $t("category.create") }}
      </button>
    </div>
    <fixed-bottom-list
      :isShowFixedCategoryBlock="isShowFixedCategoryBlock"
      :list="operationsCategories"
      :title="$t('category.choseCategory')"
      @set-is-open-fixed-list="setIsOpenFixedList"
      @on-check-item-list="checkListValueCategories"
      @set-is-open-settings-category="setIsOpenSettingsCategory"
    />
  </div>
</template>

<script>
import { XIcon } from "vue-feather-icons";
import TabInput from "../../../components/TabInput.vue";
import DateInput from "../../../components/DateInput.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import FixedTabList from "../../../components/FixedTabList.vue";
import FixedBottomList from "../../../components/FixedBottomList.vue";
import { onVibrate } from "../../../helpers/utils";
import { mapMutations } from "vuex";

export default {
  name: "Buttons-top-container",
  components: {
    XIcon,
    TabInput,
    DateInput,
    FixedTabList,
    FixedBottomList,
    VuePerfectScrollbar,
  },
  props: {
    isOpenCreatePaymentBlock: {
      type: Boolean,
      require: true,
    },
    currentCustomer: {
      type: Object,
      require: true,
    },
    isEdit: {
      type: Boolean,
      require: true,
    },
    editElement: {
      type: Object,
      require: false,
    },
    customType: {
      type: String,
      require: false,
    },
    customCurrency: {
      type: Number,
      require: false,
    },
    telegram: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      categoryValue: null,
      typeValue: null,
      usedCurrency: null,
      titleInputVal: "",
      priceInputVal: "",
      isKeyboardOpen: false,
      isShowDrawsIndex: 0,
      isShowFixedCategoryBlock: false,
      events: [],
      isShowError: false,
      isHideMainButton: false,
      typeList: [],
    };
  },
  async mounted() {
    this.telegram.MainButton.onClick(() => {
      onVibrate("click");
      const focusedElement = document.activeElement;
      if (focusedElement.id === "price-input" && !this.titleInputVal) {
        document.getElementById("title-input").focus();
      } else if (focusedElement.id === "title-input" && !this.priceInputVal) {
        document.getElementById("price-input").focus();
      } else if (!this.categoryValue) {
        focusedElement.blur();
        setTimeout(() => {
          this.isShowFixedCategoryBlock = true;
        }, 500);
      } else {
        focusedElement.blur();
      }
    });
  },

  methods: {
    ...mapMutations([
      "saveCreatedInfo",
      "setClearCreatedInfo",
      "confirmDrawOperationById",
    ]),
    checkListValueType(value) {
      let data = this.typeOperations.find((el) => el?.slug === value.slug);
      this.getFilteredCategories(data.id);
      this.typeValue = value;
      if (!this.isEdit) {
        this.saveCreatedInfo({
          ...this.createdInfo,
          types: value,
        });
      }
    },
    setIsOpenSettingsCategory() {
      this.$emit("set-is-open-settings-category");
    },
    setCloseCreatedWindow() {
      if (this.isDrawEditMode) {
        this.setClearCreatedInfo();
      }
      if (this.isShowFixedCategoryBlock) {
        this.isShowFixedCategoryBlock = false;
      }
      if (this.telegram.MainButton.isVisible) {
        this.telegram.MainButton.hide();
        this.isHideMainButton = false;
      }
      this.$emit("on-backdrop-click");
    },
    setIsOpenFixedList() {
      onVibrate("click");
      this.isShowFixedCategoryBlock = !this.isShowFixedCategoryBlock;
    },
    checkListValueCategories(value) {
      onVibrate("click");
      this.categoryValue = value;
      if (!this.isEdit) {
        this.saveCreatedInfo({
          ...this.createdInfo,
          categories: value,
        });
      }
      this.setIsOpenFixedList();
    },
    checkListCurrency(value) {
      this.usedCurrency = value;
      if (!this.isEdit) {
        this.saveCreatedInfo({
          ...this.createdInfo,
          currency: value,
        });
      }
    },
    saveCustomTitleValue(value) {
      this.titleInputVal = value;
      if (value && !this.isEdit) {
        this.saveCreatedInfo({
          ...this.createdInfo,
          title: value,
        });
      }
    },
    saveCustomPriceValue(value) {
      this.priceInputVal = value;
      if (value && !this.isEdit) {
        this.saveCreatedInfo({
          ...this.createdInfo,
          price: value,
        });
      }
    },
    createNewOperation() {
      if (
        !this.typeValue?.id ||
        !this.categoryValue?.id ||
        !this.usedCurrency?.id ||
        !this.titleInputVal ||
        !this.priceInputVal
      ) {
        this.isShowError = true;
        onVibrate("error");
        return;
      }
      this.dateVal = 1;
      this.isShowError = false;
      let currType = this.typeOperations.find(
        (el) => el?.slug === this.typeValue.slug
      );
      let data = {
        account_id: this.currentCustomer.id,
        type_id: currType.id,
        category_id: this.categoryValue.id,
        currency_id: this.usedCurrency.id,
        status: "final",
        date: this.createdDate,
        title: this.titleInputVal,
        sum: this.priceInputVal.replace(/\s/g, ""),
      };
      if (this.isEdit) {
        this.$emit("on-edit-operation", this.editElement.id, data);
      } else {
        this.setClearCreatedInfo();
        this.$emit("on-save-operation", data);
      }
    },
    toStandartValues() {
      (this.categoryValue = {}),
        (this.typeValue = {}),
        (this.usedCurrency = this.getMainCurrency);
      (this.titleInputVal = ""),
        (this.priceInputVal = ""),
        (this.isShowDrawsIndex = 0);
    },
    isOpenKeyboard(value) {
      // const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream && value) {
      if (value) {
        this.telegram.MainButton.setParams({
          text: this.$t("category.mainButtonText"),
          color: "#4A89DC",
          text_color: "#fff",
        });
        this.telegram.MainButton.show();
        this.isHideMainButton = true;
      } else {
        this.telegram.MainButton.hide();
        this.isHideMainButton = false;
      }
    },

    setDeleteOperation() {
      this.$emit(
        "on-save-payment-info",
        this.drawOperations[this.isShowDrawsIndex]
      );
      this.$emit("on-open-question-block");
    },
    setConfirmOperation() {
      if (
        !this.typeValue?.id ||
        !this.categoryValue?.id ||
        !this.usedCurrency?.id ||
        !this.titleInputVal ||
        !this.priceInputVal
      ) {
        this.isShowError = true;
        onVibrate("error");
        return;
      }
      this.isShowError = false;
      let currType = this.typeOperations.find(
        (el) => el?.slug === this.typeValue.slug
      );
      let data = {
        account_id: this.currentCustomer.id,
        type_id: currType.id,
        category_id: this.categoryValue.id,
        currency_id: this.usedCurrency.id,
        status: "final",
        date: this.createdDate,
        title: this.titleInputVal,
        sum: this.priceInputVal.replace(/\s/g, ""),
      };
      this.$emit(
        "on-edit-draw-operations",
        this.drawOperations[this.isShowDrawsIndex].id,
        data,
        this.drawOperations.length === 1
      );
      this.confirmDrawOperationById(
        this.drawOperations[this.isShowDrawsIndex].id
      );
      if (this.drawOperations.length === 1) {
        this.setClearCreatedInfo();
      }
      if (this.isShowDrawsIndex > this.drawOperations.length - 1) {
        this.isShowDrawsIndex = 0;
      }
    },
    getFilteredCategories(id) {
      this.$emit("get-type-categories", id);
    },
    showNextDrawOperation() {
      this.isShowDrawsIndex += 1;
      this.showIndexDrawOperation(this.isShowDrawsIndex);
    },
    showPreviousDrawOperation() {
      this.isShowDrawsIndex -= 1;
      this.showIndexDrawOperation(this.isShowDrawsIndex);
    },
    showIndexDrawOperation(index) {
      (this.categoryValue = this.drawOperations[index].category),
        (this.typeValue = this.drawOperations[index].type),
        (this.usedCurrency = this.drawOperations[index].currency),
        (this.titleInputVal = this.drawOperations[index].title),
        (this.priceInputVal = `${this.drawOperations[index].sum}`);
    },
  },
  computed: {
    typeOperations() {
      return this.$store.getters.typeOperations;
    },
    operationsCategories() {
      return this.$store.getters.operationsCategories;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    createdInfo() {
      return this.$store.getters.createdInfo;
    },
    isDrawEditMode() {
      return this.$store.getters.isDrawEditMode;
    },
    drawOperations() {
      return this.$store.getters.drawOperations;
    },
    getCurrentLang() {
      return this.$store.getters.getCurrentLang;
    },
    getMainCurrency() {
      return this.$store.getters.getMainCurrency;
    },
  },
  watch: {
    isOpenCreatePaymentBlock(newVal, oldVal) {
      this.typeList = [
        { id: 2, title: this.$t("analytics.costTiitle"), slug: "expense" },
        { id: 1, title: this.$t("analytics.incomeTitle"), slug: "income" },
        // { id: 3, title: this.$t('analytics.transferTitle') }
      ];
      if (this.isDrawEditMode && newVal) {
        (this.categoryValue = this.drawOperations[
          this.isShowDrawsIndex
        ].category),
          (this.typeValue = this.drawOperations[this.isShowDrawsIndex].type),
          (this.usedCurrency = this.drawOperations[
            this.isShowDrawsIndex
          ].currency),
          (this.titleInputVal = this.drawOperations[
            this.isShowDrawsIndex
          ].title),
          (this.priceInputVal = `${
            this.drawOperations[this.isShowDrawsIndex].sum
          }`);
        this.setClearCreatedInfo();
      } else if (newVal && this.isEdit) {
        (this.categoryValue = this.editElement.category),
          (this.typeValue = this.editElement.type),
          (this.usedCurrency = this.editElement.currency),
          (this.titleInputVal = this.editElement.title),
          (this.priceInputVal = `${this.editElement.sum}`);
        this.setClearCreatedInfo();
      } else if (newVal && !this.isEdit) {
        (this.categoryValue = this.createdInfo.categories),
          (this.typeValue = this.createdInfo.types),
          (this.usedCurrency =
            this.createdInfo.currency || this.getMainCurrency),
          (this.titleInputVal = this.createdInfo.title),
          (this.priceInputVal = `${this.createdInfo.price}`);
      } else {
        this.toStandartValues();
      }
      let val = oldVal;
      val;
    },
    drawOperations(newVal, oldVal) {
      if (!newVal.length) {
        return;
      }
      (this.categoryValue = this.drawOperations[
        this.isShowDrawsIndex
      ].category),
        (this.typeValue = this.drawOperations[this.isShowDrawsIndex].type),
        (this.usedCurrency = this.drawOperations[
          this.isShowDrawsIndex
        ].currency),
        (this.titleInputVal = this.drawOperations[this.isShowDrawsIndex].title),
        (this.priceInputVal = `${
          this.drawOperations[this.isShowDrawsIndex].sum
        }`);
      let val = oldVal;
      val;
    },
    customType(newVal, oldVal) {
      onVibrate("click");
      if (newVal) {
        this.typeValue = this.typeOperations.find((el) => el?.slug === newVal);
        this.getFilteredCategories(this.typeValue?.id);
      }
      let val = oldVal;
      val;
    },
    customCurrency(newVal, oldVal) {
      onVibrate("click");
      if (newVal) {
        this.usedCurrency = this.getCurrency.find((el) => el.id === newVal);
      }
      let val = oldVal;
      val;
    },
    priceInputVal() {
      onVibrate("click");
    },
    titleInputVal() {
      onVibrate("click");
    },
    getCurrentLang(newVal, oldVal) {
      let val = oldVal;
      val;
      this.typeList = [
        { id: 2, title: this.$t("analytics.costTiitle"), slug: "expense" },
        { id: 1, title: this.$t("analytics.incomeTitle"), slug: "income" },
        // { id: 3, title: this.$t('analytics.transferTitle') }
      ];
    },
  },
};
</script>

<style scoped>
.payment-info-block {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 95%;
  height: 95%;
  left: 2.5%;
  bottom: 2.5%;
  padding: 15px;
  padding-top: 80px;
  transform: translateY(110%);
  pointer-events: all !important;
  -webkit-backdrop-filter: saturate(180%) blur(80px);
  backdrop-filter: saturate(180%) blur(80px);
  background-color: rgba(255, 255, 255, 0.8);
  pointer-events: none;
  overflow: hidden;
  z-index: 1000 !important;
  border: 0px !important;
  border-radius: 20px;
  transition: all 0.5s ease;
}

.open-keyboard-style {
  top: 2.5%;
  bottom: auto;
}

.open-payment-info-block {
  transform: none;
}

.close-info-customer-modal {
  display: block;
  font-family: "Source Sans 3", sans-serif;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 12px;
  font-size: 13px;
  padding: 14px 20px;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.1);
  transition: all 120ms ease;
  background-size: cover;
  position: relative;
  z-index: 10;
  background-image: var(--main-bg-color);
  color: #fff;
  width: 100%;
  border: none;
  margin-top: auto;
  cursor: pointer;
}

.close-info-customer-modal::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.8) translateY(5px) translateZ(0px);
  filter: blur(12px);
}

.close-info-customer-modal.next {
  background-image: var(--main-bg-color);
  margin-bottom: 0px;
  padding: 12px 18px;
}

.close-info-customer-modal.previous {
  background-image: var(--main-bg-color);
  margin-bottom: 0px;
  padding: 12px 18px;
}

.edit-index-buttons-container {
  display: flex;
  gap: 20px;
  margin-top: 15px;
}

.payment-info-list-item {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.info-list-key {
  margin: 0;
  color: #0f1117;
  font-size: 13px;
  font-family: "Roboto", sans-serif;
  line-height: 24px;
  font-weight: bolder;
}

.info-list-value {
  margin: 0;
  color: #747474;
  font-size: 13px;
  font-family: "Roboto", sans-serif;
  line-height: 24px;
  font-weight: bolder;
}

.info-plist-price {
  color: #4a89dc;
}

.create-payment-header-container {
  padding-top: 4px;
  padding-bottom: 4px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.create-payment-title {
  font-size: 24px;
  line-height: 30px;
  font-weight: 700;
  color: #1b1b1b;
  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: -0.6px;
  margin-bottom: 0px;
}

.create-payment-under-title {
  font-size: 15px;
  font-weight: 400;
  color: #898888;
  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: -0.6px;
  margin-bottom: 0px;
}

.create-bayment-close-button {
  cursor: pointer;
  background: transparent;
  border: none;
  margin-left: auto;
}

.create-payment-close-icon {
  width: 26px;
  height: 26px;
  color: #d84558;
}

.change-status-payments-block {
  background-color: rgba(0, 0, 0, 0.07);
  overflow: hidden;
  display: flex;
  padding: 5px;
  border-radius: 20px;
  margin: 10px 0 10px 0;
}

.status-button {
  transition: all 200ms ease;
  text-align: center;
  width: 100%;
  margin: auto;
  color: #000;
  line-height: 35px;
  font-size: 13px;
  background-size: cover;
  position: relative;
  z-index: 10;
  overflow: visible;
  background-color: transparent;
  transition: all 0.5s ease;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 600;
}
.status-button:hover {
  background: #00000016;
}
.status-button.active {
  background-image: var(--main-bg-color);
  color: #fff !important;
}

.mx-datepicker-main {
  z-index: 99999 !important;
}

.error-message {
  font-size: 9px;
  line-height: 8px;
  color: red;
  font-weight: 600;
  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: 0.1px;
  margin-top: -5px;
  text-align: end;
}

.change-operation-container {
  display: flex;
  justify-content: space-between;
}

.change-operation-button {
  position: relative;
  font-family: "Source Sans Pro", sans-serif;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 12px;
  font-size: 13px;
  padding: 14px 20px;
  width: 50%;
  color: #fff;
  font-size: 12px;
  padding: 12px 18px;
  border: none;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.1);
  transition: all 120ms ease;
  cursor: pointer;
}

.change-operation-button.edit {
  margin-left: 10px;
  background-image: var(--main-bg-color);
}

.change-operation-button.delete {
  margin-right: 10px;
  background-image: linear-gradient(to bottom, #ed5565, #d84558);
}

.draw-buttons-main-container {
  margin-top: auto;
}

.create-block-scrollbar {
  min-height: 50vh;
}

.dropdown-categories-block {
  position: fixed;
  width: 100%;
  z-index: 1000000000;
  max-height: 80vh;
  left: 0px;
  bottom: 0px;
  background: #e8e8e8;
  transform: translateY(100%);
  transition: all 0.25s ease;
  border: 1px solid rgba(0, 0, 0, 0.07);
}

.dropdown-categories-block.show {
  transform: translateY(0);
}

.categories-item {
  display: flex;
  gap: 15px;
  background: transparent;
  padding: 15px 10px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.categories-item-text {
  font-weight: 400;
  line-height: 40px;
  font-size: 15px;
  font-family: "Source Sans 3", sans-serif;
  color: #212529;
  transition: all 0.25s ease;
}

.categories-item:hover {
  background-image: var(--main-bg-color);
  color: #fff;
}

.categories-item:hover p {
  color: #fff;
}

.category-icon-container {
  position: relative;
  width: 45px;
  height: 45px;
  background-image: var(--main-bg-color);
  border-radius: 50%;
  display: flex;
  z-index: 10;
  transition: all 0.25s ease;
}

.category-icon-container:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.75) translateY(5px) translateZ(0px);
  filter: blur(8px);
}

.category-icon {
  margin: auto;
  fill: #fff;
}

.dropdown-header-block {
  display: flex;
  padding: 15px 10px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.07);
}

.dropdown-header-title {
  font-size: 18px;
  line-height: 25px;
  font-weight: 700;
  color: #1b1b1b;
  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: -0.6px;
  margin-bottom: 0px;
}
</style>
